// extracted by mini-css-extract-plugin
export var menu_modal_label = "navigation-module--menu_modal_label--nlhRx";
export var news_nav = "navigation-module--news_nav--myLYC";
export var news_nav_desktop_display = "navigation-module--news_nav_desktop_display--m04OW";
export var news_nav_laptop_display = "navigation-module--news_nav_laptop_display--ZduXS";
export var news_nav_laptop_mobile_display = "navigation-module--news_nav_laptop_mobile_display--kL6rc";
export var news_nav_main = "navigation-module--news_nav_main--5Cykg";
export var news_nav_mobile_display = "navigation-module--news_nav_mobile_display--80Rfl";